{
  "library": {
    "header": "Bibliotek",
    "noDocumentsFound": "Inga dokument hittades",
    "filterByTitlePlaceholder": "Filtrera på titel...",
    "columns": "Kolumner",
    "rememberFilters": "Kom ihåg filter",
    "noResults": "Inga resultat.",
    "filters": {
      "before": "Före",
      "after": "Efter",
      "invalidDateRange": "Efter-datum måste vara före eller samma som Före-datum",
      "isBefore": "är före",
      "isAfter": "är efter",
      "isBetween": "är mellan",
      "equals": "är",
      "includes": "är en av",
      "notSet": "ej satt",
      "nullLabel": {
        "adoptedAt": "Ej beslutad",
        "reviewFrom": "Ingen granskning från",
        "reviewTo": "Ingen granskning till"
      }
    },
    "onboardDocuments": {
      "header": "Onboarda dokument",
      "subtitle": "Följ guiden för att onboarda dina dokument till North House",
      "leaveAlert": {
        "title": "Dokumenten är inte publicerade",
        "stay": "Stanna kvar",
        "leave": "Lämna ändå",
        "draftsDescription": "Dina dokument är skapade som utkast men är inte publicerade ännu. Fortsätt till nästa steg för att publicera dem och slutföra onboardingen.",
        "publishDescription": "Dina dokument är inte publicerade ännu. Slutför onboardingen för att publicera dem."
      },
      "steps": {
        "createDrafts": {
          "title": "Skapa utkast",
          "description": "Ladda upp era dokument och placera varje i kategori och nivå",
          "cardTitle": "Ange titel, nivå och kategori",
          "cardDescription": "Konfigurera grundläggande metadata för varje uppladdat dokument. Detta kan ändras senare.",
          "requiredField": "Obligatoriskt fält",
          "create": "Skapa dokument",
          "created": "Skapat",
          "createdLabel": "{{createdCount}} / {{totalCount}} skapade",
          "createCount": "Skapa {{count}} valda",
          "next": "Nästa",
          "clickOrDrag": "Klicka eller dra filer för att ladda upp",
          "addMore": "Lägg till fler filer",
          "duplicateFiles": "Redan uppladdade filer hoppades över",
          "unsupportedType": "\"{{name}}\" har en filtyp som inte stöds",
          "fileTooLarge": "\"{{name}}\" överskrider storleksgränsen på 50 MB",
          "clearSelected": "Ta bort {{count}} markerade",
          "duplicateWarning": "Ett icke-arkiverat dokument med denna titel finns redan i kategorin.",
          "failedToCreate": "Kunde inte skapas.",
          "removeRow": "Ta bort rad",
          "toasts": {
            "createdSome": "Skapade {{count}} dokument",
            "failedSome": "{{count}} dokument kunde inte skapas"
          }
        },
        "configureAndPublish": {
          "title": "Granska och slutför",
          "description": "Publicera dokument och slutför onboardingen",
          "cardTitle": "Granska dokumentens uppgifter",
          "cardDescription": "Ändra metadata och publicera dokumenten.",
          "completeOnboarding": "Slutför onboarding",
          "goToLibrary": "Gå till biblioteket",
          "onboardMore": "Onboarda fler dokument",
          "toasts": {
            "recurringReviewUpdated": "Återkommande granskning har uppdaterats för {{count}} dokument",
            "failedRecurringReview": "Kunde inte uppdatera återkommande granskning för {{count}} dokument",
            "published": "Publicerade {{count}} dokument",
            "failedPublish": "Kunde inte publicera {{count}} dokument"
          }
        }
      }
    }
  }
}
